import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Modal,
  IconButton ,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Tooltip,
  Card,
  Grid,
  CardContent,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetSalesOfficeOperation, getSalesOffices } from "../../utils/GetAdmin";
import { saveSalesOfficeOperation } from "../../utils/PostAdmin";
import {checkForRole} from "../../utils/GetAuth";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    checkbox: {
      padding: 0,
      "&$disabled": {
        color: theme.palette.primary.main
      }
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width:"auto"
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
      width:"auto"
    },
    modalText: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: 500,
      maxWidth: 500
    },
    modalInput: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
        minWidth: 500,
        maxWidth: 800
    },
  })
);

interface DayFlags {
  mon:boolean;
  tue:boolean;
  wed:boolean;
  thu:boolean;
  fri:boolean;
  sat:boolean;
  sun:boolean;
}
export default function AdminSalesOfficeOperation() {
  const classes = useStyles();
  const [deliveringPlantOperation, SetDeliveringPlantOperation] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vs_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  
  const handleEdit = (tableRow:any) => {
   // console.log(tableRow, "tableRow")
    setEditedRowDeliveringPlant(tableRow.delivering_plant);
    setEditedRowDays({
      sun:tableRow.sun,
      mon:tableRow.mon,
      tue:tableRow.tue,
      wed:tableRow.wed,
      thu:tableRow.thu,
      fri:tableRow.fri,
      sat:tableRow.sat,
    })
    setOpenEditWindow(true);
  }
  const flipDay = (day:"mon"|"tue"|"wed"|"thu"|"fri"|"sat"|"sun")=>{
    let row:DayFlags = (editedRowDays) ? {...editedRowDays} : {mon:false,tue:false,wed:false,thu:false,fri:false,sat:false,sun:false,};
    row[day] = !(row[day]);
    setEditedRowDays(row);
  }
  const [editedRow, setEditedRow] = React.useState<{data:any[]}|undefined>(undefined);
  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowDays, setEditedRowDays] = React.useState<DayFlags|undefined>();
  
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRowDeliveringPlant("");
    setEditedRowDays(undefined);
    setEditedRow(undefined);
  }
  const handleModalSave = () => {
    //console.log(editedRowDays,"editedRowDays")
    if(editedRowDays){
      let row = {...editedRowDays};
     // console.log(editedRowDays,)
      saveSalesOfficeOperation(salesOrg,editedRowDeliveringPlant,editedRowDeliveringPlant, row).then(ret => {
        if(ret){
          SetDeliveringPlantOperation(ret.mdSalesOfficeOperation)
          setDoneLoading(false);
          if(ret.message){
            alert(ret.message);
          }
        }
      });
    }
    
    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 

  useEffect(() => {
    if (doneLoading) return;
    if(!deliveringPlantOperation || deliveringPlantOperation.length === 0){
      requestMissingContexts(["SALESOFFICES", "PLANTS"])
      .then((v) => {
        //console.log(v, "V")
        setCodes(v);
      })
      .then((_) => {
        GetSalesOfficeOperation(salesOrg).then((v) => {
          if(v && v.mdSalesOfficeOperation) SetDeliveringPlantOperation(v.mdSalesOfficeOperation);
        }).then((_) => {
          getSalesOffices(salesOrg)
            .then((v) => {
              setDeliveringPlants(v);
              setDoneLoading(true);
            });
          });
        });
    } else {setDoneLoading(true)}
  }, [deliveringPlantOperation, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
        <TableAbstraction
        settingsKey="ADM_SOO"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Delivery Plant`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Delivery Plant Operation Days"
          columns={[
            {
              label: "Sales Office",
              name: "sales_office",
              options: {
                searchable: true,
                filter: true,
                customBodyRender: (value: any) =>{
                  return (value === '*' ? `${salesOrg} - Default` :`${value} - ${determineConfig(codes, "SALESOFFICES", value)}`)
                }
              },
            },
            {
              label: "Delivery Plant",
              name: "delivering_plant",
              options: {
                searchable: true,
                filter: true,
                customBodyRender: (value: any) =>{
                  return (value === '*' ? `${salesOrg} - Default` :`${value} - ${determineConfig(codes, "PLANTS", value)}`)
                }
              },
            },
            {
              label: "Sun",
              name: "sun",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Mon",
              name: "mon",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Tue",
              name: "tue",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Wed",
              name: "wed",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Thu",
              name: "thu",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Fri",
              name: "fri",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: "Sat",
              name: "sat",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value:boolean) => (<Checkbox checked={value} disabled={true} className={classes.checkbox}/>) ,
              },
            },
            {
              label: " ",
              name: "remove",
              options: {
                searchable: false,
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (params) => {
                  if(!!useCompact)
                    return (
                        <Tooltip title={"Edit"}>
                          <EditIcon 
                            fontSize="small"  
                            onClick={() => {handleEdit(params.row)}}/>
                        </Tooltip>
                      );
                    else
                      return (
                          <Tooltip title={"Edit"}>
                            <IconButton onClick={() => {handleEdit(params.row)}}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        );
                },
              },
            },
          ]}
          data={deliveringPlantOperation}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Vend Smart Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        <div style={modalStyle} className={classes.paper} >
          <Typography variant="h4" className={classes.modalTitle} paragraph>Operation Days</Typography>
          <Grid container spacing={2} className={classes.modalGrid}>
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <Card className={classes.modalCard}>
                <CardContent>
                <Grid container spacing={1} className={classes.modalGrid}>
                  <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                    <InputLabel >Delivery Plant</InputLabel>
                    <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                        disabled={(editedRow === undefined)?false:true}
                        inputProps={{name: 'Delivery Plant',}}
                        className={classes.modalInput}
                        onChange={(e) => { 
                          setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                            }}>
                        <MenuItem key='*' value='*'>{salesOrg + " - All"}</MenuItem>
                        {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                          
                            <MenuItem key={so[1].code} value={so[1].code}>
                              {so[1].code + " - " + so[1].text}
                            </MenuItem>
                            ))):(<div></div>)}
                    </Select>
                  </Grid>
                  <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="right">Sun</TableCell>              
                            <TableCell align="right">Mon</TableCell>           
                            <TableCell align="right">Tue</TableCell>           
                            <TableCell align="right">Wed</TableCell>           
                            <TableCell align="right">Thu</TableCell>           
                            <TableCell align="right">Fri</TableCell>           
                            <TableCell align="right">Sat</TableCell>           
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>  
                            <TableCell align="right"><Checkbox checked={editedRowDays?.sun} onClick={()=>flipDay("sun")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.mon} onClick={()=>flipDay("mon")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.tue} onClick={()=>flipDay("tue")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.wed} onClick={()=>flipDay("wed")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.thu} onClick={()=>flipDay("thu")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.fri} onClick={()=>flipDay("fri")}/></TableCell>
                            <TableCell align="right"><Checkbox checked={editedRowDays?.sat} onClick={()=>flipDay("sat")}/></TableCell>
                          </TableRow>  
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  </Grid>
                  </CardContent>
                </Card>
                <div style={{ paddingRight: "5px", textAlign:"right"}}>
                      <React.Fragment>
                          <Tooltip title={"Save"}>
                              <IconButton onClick={handleModalSave}>
                                  <SaveIcon />
                              </IconButton>
                          </Tooltip>
                          <Tooltip title={"Cancel"}>
                              <IconButton onClick={handleModalClose}>
                                  <Clear />
                              </IconButton>
                          </Tooltip>
                      </React.Fragment>
                    </div>
              </Grid>
            </Grid>
          </div>
      </Modal>
    </div>
  );
}